import { BasicService } from "./core/basic.service";

export class PowerService extends BasicService {

  static async getMenuList() {
    const data = await this.http.post('/power/getMenuAndPower')
    this.handleMainMenu(data.left_menu);
    return Promise.resolve(data);
  }

  static handleMainMenu(treeData = []) {
    if (treeData && treeData.length) {
      for (let i = 0; i < treeData.length; i++) {
        if (treeData[i]
          && (treeData[i].type === '0'
            || ( treeData[i].type === '2'
              && (!treeData[i].sub || !treeData[i].sub.length)))) {
          treeData.splice(i, 1);
        }
        if (treeData[i]) {
          this.handleMainMenu(treeData[i].sub);
        }
        if (treeData[i]
            && (treeData[i].type === '0'
              || ( treeData[i].type === '2'
                && (!treeData[i].sub || !treeData[i].sub.length)))) {
          treeData.splice(i, 1);
        }
      }
    }
  }

  static getPowerList(id) {
    return this.http.post('/power/Index', { id });
  }
  static getCTLmodule() {
    return this.http.post('/Power/getCtl', { module:'api' })
  }
  static getActmodule(query) {
    return this.http.post('/Power/getAct',query)
  }
  static async getPowerMenuList() {
    let data = await this.http.post('/power/Index');
    data = data.filter(item => item.type != '0');
    const stack = [...data];
    let flag = stack.pop();
    while (flag) {
      if (flag.sub && flag.sub.length) {
        const menuList = flag.sub.filter(item => item.type != '0')
        flag.sub = menuList;
        stack.unshift(...flag.sub);
      }
      flag = stack.pop();
    }
    return Promise.resolve(data);
  }

  static getRoleList() {
    return this.http.post('/power/RoleList')
  }

  static addRole(act_list,role_name) {
    return this.http.post('/power/RoleSave',{ act_list ,role_name })
  }

  static detail(id) {
    return this.http.post('/power/detail', { id });
  }

  static addOrEditResource(data) {
    const reqData = JSON.parse(JSON.stringify(data));
    delete reqData.pids;
    return this.http.post('/power/PowerSave', reqData);
  }

  static deleteResource(id) {
    return this.http.post('/power/PowerDelete', { id });
  }
}